import { TimesheetsListData, BasicData } from '@app/models/row-data.interface';

export const defaultTimesheetSort = (timesheet1: TimesheetsListData, timesheet2: TimesheetsListData): number =>
  sortByYear(timesheet1, timesheet2);

const sortByYear = (timesheet1: TimesheetsListData, timesheet2: TimesheetsListData): number => {
  const sortingOrder = timesheet2.year - timesheet1.year;
  return sortingOrder === 0 ? sortByMonths(timesheet1, timesheet2) : sortingOrder;
};

const sortByMonths = (timesheet1: TimesheetsListData, timesheet2: TimesheetsListData): number => {
  if (typeof timesheet1.month === 'number' && typeof timesheet2.month === 'number') {
    const sortingOrder = timesheet2.month - timesheet1.month;
    return sortingOrder === 0 ? sortByName(timesheet1, timesheet2) : sortingOrder;
  }
};

export const sortByName = (datablock1: BasicData, datablock2: BasicData): number => {
  return datablock1.fullName.localeCompare(datablock2.fullName);
};
